import { Box, Button, Modal, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useEffect } from 'react';
import { useUtil } from '../hooks/useUtil';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appModal: {
      backgroundColor: theme.palette.background.default,
      width: '95%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow:
        '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
      borderRadius: '5px',
      '& .btns': {
        textAlign: 'right',
        marginRight: '-8px',

        '& .MuiButton-root': { fontSize: '14px !important' }
      },
      maxHeight: 'calc(100vh - 80px)',
      overflowY: 'auto',
      color: 'rgba(0,0,0,0.87)',
      scrollbarWidth: 'thin',

      '&::-webkit-scrollbar': {
        width: '6px',
        borderRadius: '3px',
        transition: '200ms'
      },

      '&::-webkit-scrollbar-track': {
        borderRadius: '3px',
        '&:hover': {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },

      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '3px',
        '&:hover': {
          background: 'rgba(0, 0, 0, 0.35)'
        }
      }
    }
  })
);

const AppModal = ({
  children,
  title,
  open,
  handleClose,
  handleSubmit,
  maxWidth = '677px',
  minWidth,
  child = false,
  closeButton = 'close',
  saveButton = 'Save',
  disabled = false,
  loading = false,
  className = '',
  hideModalSaveButton,
  outSideClickClose = true,
  doNothing,
  customButtons,
  closeButtonDisbale = false
}: any) => {
  const classes = useStyles();
  const { openModal, closeModal } = useUtil();

  useEffect(() => {
    if (!child) {
      if (open) {
        openModal();
      } else {
        closeModal();
      }
      return () => {
        closeModal();
      };
    }
  }, [open]);

  return (
    <Modal open={open} aria-labelledby="modal-title" onClose={outSideClickClose ? doNothing : handleClose}>
      <Box
        id="modal-title"
        pt={2}
        pb={1}
        px={3}
        className={`${classes.appModal} ${className}`}
        sx={{ maxWidth, minWidth }}
      >
        {title && (
          <Typography pb={2} variant="subtitle1" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        )}
        {children}
        <Box mt={2} className="btns">
          <Button className="grey-btn" onClick={handleClose} disabled={closeButtonDisbale}>
            {closeButton}
          </Button>
          {!customButtons && (
            <Button
              sx={{
                display: hideModalSaveButton ? 'none' : undefined
              }}
              onClick={handleSubmit}
              disabled={disabled || loading}
            >
              {saveButton}
            </Button>
          )}
          {customButtons &&
            Object.keys(customButtons).map((item: any, key: any) => (
              <Button onClick={customButtons[item]['callBack']} key={item} sx={{ color: customButtons[item]['color'] }}>
                {item}
              </Button>
            ))}
        </Box>
      </Box>
    </Modal>
  );
};

export default AppModal;
